/* eslint-disable */
export default {
  methods: {
    created_sys() {
      ///系统方法 判断页面大小 使其自动适应
      let $this = this
      this.w = this.w === undefined ? 1920 : this.w
      $this.css = $this.fullScreenCss($this, this.screentype)
      window.addEventListener('resize', () => {
        $this.css = $this.fullScreenCss($this, this.screentype)
      })
      if (this.loadfunmounted_sys !== undefined) {
        this.$nextTick(() => {
          this.loadfunmounted_sys()
        })
      }
    },
    loadfunmounted_sys() {
      if (this.loadsysmounted !== undefined) {
        this.loadsysmounted();
      }
      if (this.loadfunmounted !== undefined) {
        let isreturn = this.loadfunmounted();
        if (isreturn == false) {
          return;
        }
      }
    },
    fullScreenCss(t, e) {
      const winW = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      const winH = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      if ("none" === e) return `  width: ${t.w}px;height: ${t.h}px; ${"" === t.bg ? "" : "background-image:url(" + t.bg + ");    background-repeat: no-repeat;background-size: cover;"}    ${"" === t.bgColor ? "" : "background-color:" + t.bgColor + ";"}`;
      if ("w" === e) return `  width: ${t.w}px;height: ${t.h}px; ${"" === t.bg ? "" : "background-image:url(" + t.bg + ");    background-repeat: no-repeat;background-size: cover;"}  transform: scale(${winW / t.w});  ${"" === t.bgColor ? "" : "background-color:" + t.bgColor + ";"}`;
      if ("h" === e) return `  width: ${t.w}px;height: ${t.h}px; ${"" === t.bg ? "" : "background-image:url(" + t.bg + ");    background-repeat: no-repeat;background-size: cover;"}  transform: scale(${winH / t.h});  ${"" === t.bgColor ? "" : "background-color:" + t.bgColor + ";"}`;
      if ("full" === e) return `  width: ${t.w}px;height: ${t.h}px; ${"" === t.bg ? "" : "background-image:url(" + t.bg + ");    background-repeat: no-repeat;background-size: cover;"}  transform: scale(${winW / t.w},${winH / t.h});  ${"" === t.bgColor ? "" : "background-color:" + t.bgColor + ";"}`;
      {
        let eh = winH / t.h,
          ew = winW / t.w,
          i = eh > ew ? ew : eh,
          o = (winW - i * t.w) / 2;
        return o = o > 0 ? "left:" + o + "px;" : "", o + ` transform: scale(${i}); width: ${t.w}px;height: ${t.h}px; ${"" === t.bg ? "" : "background-image:url(" + t.bg + ");    background-repeat: no-repeat;background-size: cover;"} ${"" === t.bgColor ? "" : "background-color:" + t.bgColor + ";"}`
      }
    }
  }
}
